import React, { forwardRef } from "react";

const TimeLine = forwardRef(({ position = "left", isTop = false }, ref) => {
  const startHour = 9;
  const endHour = 20;
  const intervals = 15;

  const times = [];
  for (let hour = startHour; hour < endHour; hour++) {
    for (let min = 0; min < 60; min += intervals) {
      const hour12 = hour % 12 === 0 ? 12 : hour % 12;
      const ampm = hour < 12 ? "AM" : "PM";
      const displayMin = min.toString().padStart(2, "0");
      const isExactHour = min === 0;
      times.push({
        label: `${hour12}:${displayMin} ${ampm}`,
        isBold: isExactHour,
      });
    }
  }

  return (
    <div
      ref={ref}
      className={`timeline-container ${
        position === "right" ? "timeline-right" : ""
      } ${isTop ? "timeline-top" : ""}`}
    >
      {times.map((time, idx) => (
        <div
          className={`timeline-item ${time.isBold ? "highlight" : ""}`}
          key={idx}
        >
          {time.label}
        </div>
      ))}
    </div>
  );
});

TimeLine.displayName = "TimeLine";

export default TimeLine;
